import { JobRoleCard } from './JobRoleCard'
import { LearningMotivations } from './LearningMotivations'
import { SeniorityCard } from './SeniorityCard'
import { WorkConfidence } from './WorkConfidence'
import { WorkSatisfactionCard } from './WorkSatisfaction'

export * from './JobRoleCard'
export * from './LearningMotivations'
export * from './SeniorityCard'
export * from './WorkConfidence'
export * from './WorkSatisfaction'

export const questions = {
  seniority: SeniorityCard,
  department: JobRoleCard,
  learning_motivations: LearningMotivations,
  confidence_at_work: WorkConfidence,
  satisfaction_at_work: WorkSatisfactionCard
}
